import { createSlice } from '@reduxjs/toolkit';
import { saveDraftDistributionApi } from '../../../rtk-apis/hl7/saveDraftDistribution';

const initialState = {
  status: '',
  result: null as any,
  msg: '',
  loading: false,
};

const saveDraftDistributionSlice = createSlice({
  name: 'saveDraftDistribution',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.result = null;
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(saveDraftDistributionApi.pending, state => {
        state.loading = true;
      })
      .addCase(saveDraftDistributionApi.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.result = action.payload;
        state.msg = action.payload?.msg || 'Saved as draft';
      })
      .addCase(saveDraftDistributionApi.rejected, (state, action) => {
        state.loading = false;
        state.status = 'FAILED';
        state.msg = (action.payload as string) || 'Save draft failed';
      });
  },
});

export const { clearState: clearSaveDraftDistributionState } = saveDraftDistributionSlice.actions;
export default saveDraftDistributionSlice.reducer;
